<template>
  <section>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'content-item'
}
</script>
